export const event = ({ action, params }) => {
  if (typeof window !== 'undefined') {
    window.gtag('event', action, params);
  }
};